import { modalStore } from '@stores'

function addProperty(Vue, property, value) {
    Object.defineProperty(Vue.prototype, property, {
        get () { return value }
    })
}

export default {
    install (Vue) {

        // Register store properties.
        addProperty(Vue, '$modals', modalStore)
    }
}
